import { Box } from '@material-ui/core'
import { unwrapResult } from '@reduxjs/toolkit'
import GoBack from 'components/GoBack'
import FitContentPaper from 'components/Paper/FitContentPaper'
import { FormikHelpers } from 'formik'
import useRestricter from 'hooks/useRestricter'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { RouteConfigComponentProps } from 'react-router-config'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { offeringListThunk, selectCurrentTempleOfferings } from 'store/reducers/temple/offeringSlice'
import { staffAssignmentCreateThunk, selectStaffAssignmentStatus } from 'store/reducers/temple/staffAssignmentSlice'
import { selectCurrentTempleStaffProfiles, staffProfileListThunk } from 'store/reducers/temple/staffProfileSlice'
import { StaffPujaAssignmentPayloadType } from 'types/api/temple'
import { getFieldErrors } from 'utils/api'
import { PERMISSIONS, RESTRICTED_PATHS } from 'utils/permissions'
import FormStaffAssignment from './FormStaffAssignment'

const AddStaffAssignment: React.FC<RouteConfigComponentProps> = props => {
    const dispatch = useAppDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const api = useAppSelector(selectStaffAssignmentStatus)
    const profiles = useAppSelector(selectCurrentTempleStaffProfiles)
    const offerings = useAppSelector(selectCurrentTempleOfferings)
    const hasAddPermission = useRestricter(PERMISSIONS.ADD, RESTRICTED_PATHS.STAFF_ASSIGNMENTS)

    useEffect(() => {
        dispatch(staffProfileListThunk({}))
        dispatch(offeringListThunk({}))
    }, [dispatch])

    const handleSubmit = (data: StaffPujaAssignmentPayloadType, actions: FormikHelpers<StaffPujaAssignmentPayloadType>) => {
        dispatch(staffAssignmentCreateThunk(data))
            .then(unwrapResult)
            .then(response => {
                enqueueSnackbar(`Assignment created for ${response.staffName}`, { variant: 'success' })
                actions.resetForm()
            })
            .catch(err => {
                Object.entries(getFieldErrors(data, err)).forEach(([key, value]) => actions.setFieldError(key, value))
            })
            .finally(() => actions.setSubmitting(false))
    }

    if (!hasAddPermission) return null

    return (
        <GoBack {...props}>
            <FitContentPaper>
                <Box component='h4' mb={4}>Add Staff Assignment</Box>
                <FormStaffAssignment
                    priests={profiles.filter(profile => profile.roleType === 'priest' && profile.isActive)}
                    offerings={offerings}
                    buttonLabel='Create'
                    api={api}
                    onSubmit={handleSubmit}
                />
            </FitContentPaper>
        </GoBack>
    )
}

export default AddStaffAssignment
